import { Badges, H5, P } from "../../../../AbstractElements";
import { BlogTextTime, BlogTime, BlogTimelineTitle, ImplementedTheProgramForWeeklyCodeChallenges } from "../../../../Constant";

const BlogTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img bg-danger">
        <i className="icon-youtube" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="danger">{BlogTimelineTitle}</Badges>
        </div>
        <H5 className="m-0 vertical-timeline-element-subtitle">{ImplementedTheProgramForWeeklyCodeChallenges}</H5>
        <P className="mb-0">
          Challenges <em className="txt-danger">{BlogTextTime}</em>
          {BlogTime}
        </P>
        <div className="ratio ratio-21x9 m-t-20">
          <iframe src="https://www.youtube.com/embed/sqRk0Ly66Ps" title="myFrame" allowFullScreen></iframe>
        </div>
        <span className="cd-date">March 12 2022</span>
      </div>
    </div>
  );
};
export default BlogTimeline;
